import { SxProps, Theme } from '@mui/material';
import { TEXT_DARK } from '../../../styles/GlobalStyles';

export const summaryHeaderStyles = {
  container: (theme: Theme) =>
    ({
      width: 'auto',
      display: 'flex',
      flexWrap: 'nowrap',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      listStyle: 'none',
      marginTop: '20px',
      marginBottom: '20px',
    }) as SxProps<Theme>,

  card: (theme: Theme) =>
    ({
      width: '110px',
      height: '110px',
      minWidth: '110px',
      minHeight: '110px',
      aspectRatio: '1 / 1',
      padding: theme.spacing(1, 2),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      textAlign: 'center',
      boxShadow: 'none',
      backgroundColor: theme.palette.primary.main,
      border: `1px solid ${theme.palette.primary.main}`,
      borderRadius: '6px',
    }) as SxProps<Theme>,

  value: (theme: Theme) =>
    ({
      margin: 0,
      marginBottom: 0,
      fontSize: '34px',
      fontWeight: 500,
      lineHeight: 1.2,
      color: '#fff',
      marginTop: theme.spacing(2.5),
    }) as SxProps<Theme>,

  label: (theme: Theme) =>
    ({
      marginTop: theme.spacing(1.5),
      fontSize: '14px',
      color: theme.palette.primary.contrastText,
      fontWeight: 400,
      lineHeight: 1.2,
      marginBottom: '2px',
    }) as SxProps<Theme>,

  separatorContainer: (theme: Theme) =>
    ({
      width: theme.spacing(14),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexShrink: 0,
    }) as SxProps<Theme>,

  separator: (theme: Theme) =>
    ({
      fontSize: '20px',
      fontWeight: 500,
      color: TEXT_DARK,
      whiteSpace: 'nowrap',
      fontFamily: 'Handwritten, monospace',
    }) as SxProps<Theme>,
};

export default summaryHeaderStyles;
